import React, { useState, } from 'react';
import { queryFamilyMembers } from "../../service/FamilyQueryApi";
import { useCheckAccess } from "../../utils/Utilities";
import { Loading } from "../../components/shared";

const FamilyMemberListCSV = () => {
  useCheckAccess('FamilyAdmin');



  const [familyMembers, setFamilyMembers] = useState([]);
  const [loading, setLoading] = useState(false);




  const fetchFamilies = async () => {
    setLoading(true);
    try {

      const resp = await queryFamilyMembers();
      if (resp && Array.isArray(resp.familyMembers)) {
        setFamilyMembers(resp.familyMembers);
      } else {
        console.warn("Unexpected familyMembers response", resp);
        setFamilyMembers([]);
      }
    } catch (err) {
      console.error("Error fetching familyMembers", err);
      setFamilyMembers([]);
      alert("Error fetching familyMembers: " + err.message);
    } finally {
      setLoading(false);
    }
  };


  const downloadCsv = () => {
    if (!familyMembers.length) {
      alert("No data to download");
      return;
    }

    // Collect all unique headers from all records
    const headers = Array.from(
      new Set(familyMembers.flatMap(obj => Object.keys(obj)))
    );

    const csvRows = [
      headers.join(','), // Header row
      ...familyMembers.map(fam =>
        headers.map(h => {
          let val = fam[h];
          if (val === null || val === undefined) return '';
          const str = String(val).replace(/"/g, '""');
          return `"${str}"`;
        }).join(',')
      )
    ];

    const csvString = csvRows.join('\n');
    const blob = new Blob(["\uFEFF" + csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `family_members_${Date.now()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };


  return (
    <div className="general_parent">
      <div className="general_container">
        <div className="general_body">

          <h1>குடும்ப உறுப்பினர்கள்</h1>





          <button onClick={fetchFamilies} disabled={loading}>
            {loading ? "பெறுகிறது..." : "குடும்ப உறுப்பினர்களைப் பெறுங்கள்"}
          </button>
          <button onClick={downloadCsv} disabled={loading || familyMembers.length === 0}>
            Download CSV
          </button>

          {loading ? (
            <Loading />
          ) : (
            <div style={{ marginTop: '1rem', maxHeight: '400px', overflowY: 'auto' }}>
              <table border="1" cellPadding="4">
                <thead>
                  <tr>
                    {familyMembers.length > 0 && Object.keys(familyMembers[0]).map(h => <th key={h}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {familyMembers.map((fam, idx) => (
                    <tr key={idx}>
                      {Object.keys(fam).map(h => <td key={h}>{fam[h]}</td>)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FamilyMemberListCSV;
